import { Component, OnInit,Inject, ViewEncapsulation,OnDestroy } from '@angular/core';
import { HttpService } from '../http.service';
import { Subscription, VirtualTimeScheduler } from 'rxjs';
import { EventService } from '../event.service';
import { DOCUMENT } from '@angular/common';
import { SnackbarService } from 'src/app/snackbar.service';
import { EChartOption } from 'echarts';
import * as echarts from 'echarts';
import { DateTime } from 'luxon';
import { StorageService } from '../storage.service';


@Component({
  selector: 'app-carrier-scorecard',
  templateUrl: './carrier-scorecard.component.html',
  styleUrls: ['./carrier-scorecard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CarrierScorecardComponent implements OnInit, OnDestroy {
  constructor(private http: HttpService,private events: EventService, @Inject(DOCUMENT) private _document, private snackbar: SnackbarService,
         private storage: StorageService) { }
  selectedUnit: any = {
    _id: '',
    name: ''
  };
  selectedType: any;
  shipperId: Subscription;
  //gauge variables
  public assignCanvasWidth
  public rejectCanvasWidth
  public acceptCanvasWidth
  public nonfullfilledCanvasWidth;
  public fulfilledCanvasWidth;
  public canvasWidth
  public pickUpcanvasWidth
  public ReductioncanvasWidth
  public needleValue
  public centralLabel
  public assignCentralLabel
  public rejectCentralLabel
  public acceptCentralLabel
  public non_fullfilledCentralLabel
  public fulfilledCentralLabel
  public label
  public bottomLabel
  public pickupBottomLabel;
  public ReductionBottomLabel
  public pickupNeedleValue;
  public pickuNeedleValue;
  public ReductionNeedleValue;
  public pickupcentralLabel;
  public ReductioncentralLabel;
  pickUpOptions = {
    hasNeedle: true,
    needleColor: '#52575D',
    needleUpdateSpeed: 1000,
    arcColors: ['#0066cc', '#99ccff'],
    arcDelimiters: [],
    rangeLabel: ['0', '100'],
    needleStartValue: 0,
  }
  options = {
    hasNeedle: true,
    needleColor: '#52575D',
    needleUpdateSpeed: 1000,
    arcColors: ['#0066cc', '#99ccff'],
    arcDelimiters: [],
    rangeLabel: ['0', '100'],
    needleStartValue: 0,
    }
    rotatedAngle = 215;
   //cirlce bar variables
   percent;
   dedicatedVehicles;
   totalVehicles;
   tenure = '';
  duration = ['Monthly','Yearly','Select a Date Range'];
  types = ['Percentage','Number']
  units = [];
  EPODpercentageValue=0;
  BillpercentageValue=0;
  APPpercentageValue=0;
  GPSpercentageValue=0;
  GPSvalue = '0%';
  APPvalue = '0%';
  EpodValue = '0%';
  billingValue = '0%';
  shiftValGPS = '0%';
  shiftValAPP = '0%';
  shiftValEPOD = '0%';
  shiftValbilling = '0%';
  VehicleAgepercent = 0;
  Vehicledivpercent= 0;
  YardInpercent =0;
  acceptindent =0;
  assignedVehicle=0;
  damagedDeliveries=0;
  //overall chart options variables
  overallOptions:any;
  overallScore = 0;
  duration_for_assign_reject= {
    name: '30 Days',
    value: '30days'
  };
  durationForAssignReject = [
  { name: 'Select a Date Range',
    value: 'date_range'
  },
  {
    name: 'Yearly',
    value: 'yearly'
  },{
    name: '90 Days',
    value: '90days'
  },{
    name: '60 Days',
    value: '60days'
  },{
    name: '30 Days',
    value: '30days'
  },{
    name: 'Today',
    value: 'today'
  },
  {
    name: 'Yesterday',
    value: 'yesterday'
  },
];
isDateRange:boolean = false;
isDate_rangeServiceQuality:boolean = false;
allUnit:boolean = false;
assignBottomlabel = '0%';
assignNeedleValue = 0;
rejectBottomlabel = '0%';
rejectNeedleValue = 0;
acceptBottomlabel = '0%';
acceptNeedleValue = 0;
non_fullfilledBottomlabel = '0%';
fulfilledBottomlabel = '0%';
non_fullfilledNeedleValue = 0;
fulfilledNeedleValue = 0;
assignOptions = {
  hasNeedle: true,
  needleColor: '#52575D',
  needleUpdateSpeed: 1000,
  arcColors: ['#631D4F', '#d973ba'],
  arcDelimiters: [],
  rangeLabel: ['0', '100'],
  needleStartValue: 0,
  }
rejectOptions = {
  hasNeedle: true,
  needleColor: '#52575D',
  needleUpdateSpeed: 1000,
  arcColors: ['#631D4F', '#d973ba'],
  arcDelimiters: [],
  rangeLabel: ['0', '100'],
  needleStartValue: 0,
  }
  acceptOptions = {
    hasNeedle: true,
    needleColor: '#52575D',
    needleUpdateSpeed: 1000,
    arcColors: ['#631D4F', '#d973ba'],
    arcDelimiters: [],
    rangeLabel: ['0', '100'],
    needleStartValue: 0,
    }
    non_fullfilledOptions = {
      hasNeedle: true,
      needleColor: '#52575D',
      needleUpdateSpeed: 1000,
      arcColors: ['#631D4F', '#d973ba'],
      arcDelimiters: [],
      rangeLabel: ['0', '100'],
      needleStartValue: 0,
      }
      fulfilledOptions = {
        hasNeedle: true,
        needleColor: '#52575D',
        needleUpdateSpeed: 1000,
        arcColors: ['#631D4F', '#d973ba'],
        arcDelimiters: [],
        rangeLabel: ['0', '100'],
        needleStartValue: 0,
        }
        ReductionOptions = {
          hasNeedle: true,
          needleColor: '#52575D',
          needleUpdateSpeed: 1000,
          arcColors: ['#631D4F', '#d973ba'],
          arcDelimiters: [],
          rangeLabel: ['0', '100'],
          needleStartValue: 0,
          }
  durationName='30 Days';
  totalAllocated = 0;
  fromDate:any;
  toDate:any;
  ngOnInit() {
    this.selectedType = this.types[0];
    this._document.body.classList.add('bodycolor');
    this.tenure = 'Monthly';
    this.getShippers();
    this.percent = 0;
    this.dedicatedVehicles=0;
    this.totalVehicles=0;
    this.canvasWidth = 250;
    this.pickUpcanvasWidth = 250;
    this.ReductioncanvasWidth = 250;
    this.assignCanvasWidth = 250;
    this.rejectCanvasWidth = 250;
    this.acceptCanvasWidth = 250;
    this.nonfullfilledCanvasWidth = 250;
    this.fulfilledCanvasWidth = 250;
    this.needleValue = 0
    this.centralLabel = ''
    this.assignCentralLabel = '';
    this.rejectCentralLabel = '';
    this.acceptCentralLabel = '';
    this.non_fullfilledCentralLabel = '';
    this.fulfilledCentralLabel = '';
    this.bottomLabel = '0%'
    this.options.arcDelimiters=[1];
    this.assignBottomlabel = '0%';
    this.assignNeedleValue = 0;
    this.assignOptions.arcDelimiters=[1];
    this.rejectBottomlabel = '0%';
    this.rejectNeedleValue = 0;
    this.rejectOptions.arcDelimiters=[1];
    this.pickupBottomLabel = '0%';
    this.pickupNeedleValue = 0;
    this.pickupcentralLabel = '';
    this.pickUpOptions.arcDelimiters=[1];
    this.acceptNeedleValue = 0;
    this.acceptBottomlabel = '0%';
    this.non_fullfilledNeedleValue = 0;
    this.non_fullfilledBottomlabel = '0%';
    this.fulfilledBottomlabel = '0%';
    this.fulfilledNeedleValue = 0;
    this.acceptOptions.arcDelimiters=[1];
    this.non_fullfilledOptions.arcDelimiters=[1];
    this.fulfilledOptions.arcDelimiters=[1];
    this.ReductionBottomLabel = '0%';
    this.ReductionNeedleValue = 0;
    this.ReductionOptions.arcDelimiters=[1];
    this.ReductioncentralLabel = '';
    this.durationName= '30 Days';
    this.totalAllocated = 0;
    this.isDateRange=false;
    this.isDate_rangeServiceQuality=false;
    this.fromDate = '';
    this.toDate = '';
    // this.getAssignRejectPercentage();
    // this.selectUnit(this.units[0]);
    this.shipperId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.tenure = 'Monthly';
        this.durationName= '30 Days';
        this.getShippers();
        this.resetAll();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
   
}
ngOnDestroy() {
  // remove the class form body tag
  this._document.body.classList.add('bodycolor');
}
resetAll(){
  this.selectedType = this.types[0];
  this._document.body.classList.add('bodycolor');
  this.tenure = 'Monthly';
  this.percent = 0;
  this.dedicatedVehicles=0;
  this.totalVehicles=0;
  this.canvasWidth = 250
  this.pickUpcanvasWidth = 250;
  this.ReductioncanvasWidth = 250;
  this.isDate_rangeServiceQuality=false;
  this.resetServiceQuality();
}

resetServiceQuality(){
  this.assignCanvasWidth = 250
  this.rejectCanvasWidth = 250
  this.acceptCanvasWidth = 250
  this.nonfullfilledCanvasWidth = 250
  this.fulfilledCanvasWidth = 250;
  this.needleValue = 0
  this.centralLabel = ''
  this.assignCentralLabel = '';
  this.rejectCentralLabel = '';
  this.acceptCentralLabel = '';
  this.non_fullfilledCentralLabel = '';
  this.fulfilledCentralLabel = '';
  this.bottomLabel = '0%'
  this.options.arcDelimiters=[1];
  this.assignBottomlabel = '0%';
  this.assignNeedleValue = 0;
  this.rejectBottomlabel = '0%';
  this.rejectNeedleValue = 0;
  this.assignOptions.arcDelimiters=[1];
  this.rejectOptions.arcDelimiters=[1];
  this.pickupBottomLabel = '0%';
  this.pickupNeedleValue = 0;
  this.pickupcentralLabel = '';
  this.pickUpOptions.arcDelimiters=[1];
  this.acceptNeedleValue = 0;
  this.acceptBottomlabel = '0%';
  this.non_fullfilledNeedleValue = 0;
  this.fulfilledNeedleValue = 0;
  this.non_fullfilledBottomlabel = '0%';
  this.fulfilledBottomlabel = '0%';
  this.acceptOptions.arcDelimiters=[1];
  this.non_fullfilledOptions.arcDelimiters=[1];
  this.fulfilledOptions.arcDelimiters=[1];
  this.ReductionBottomLabel = '0%';
  this.ReductionNeedleValue = 0;
  this.ReductionOptions.arcDelimiters=[1];
  this.ReductioncentralLabel = '';
  this.durationName= '30 Days';
  this.totalAllocated = 0;
  this.isDateRange=false;
  this.fromDate = '';
  this.toDate = '';
  }
  getShippers() {
    const option = {
      exclude_uvf: true,
      exclude_blocked: true
    };
    this.units = [];
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const shippers = data.data;
          shippers.forEach(element => {
          const temp: any = {};
          temp._id = element._id;
          temp.parent_name = element.parent_name;
          temp.name = element.name;
          this.units.push(temp);
        });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
    // shippers.forEach(element => {
    //   const temp: any = {};
    //   temp._id = element._id;
    //   temp.parent_name = element.parent_name;
    //   temp.name = element.name;
      // this.units.push(temp);
    // });

    setTimeout(()=>{  
      this.selectedUnit = this.units[0];   
      this.getAssignRejectPercentage();      
   }, 500);
}


  selectUnit(unit:any){
    this.selectedUnit = unit;
      // console.log('unitt',unit);
      if(this.tenure!==''){
        this.getAssignRejectPercentage();
      }
  }

  setOptionType(valType: any){
    this.selectedType = valType;
  // console.log('this',this.selectedType);

  }

changeDuration(duration){
  if(duration.name === 'Select a Date Range'){
    this.isDate_rangeServiceQuality = true;
    this.resetServiceQuality();
    this.duration_for_assign_reject = duration;
    this.durationName = duration.name;
  } else{
    this.duration_for_assign_reject = duration;
   this.durationName = duration.name;
    this.isDate_rangeServiceQuality = false;
    this.getAssignRejectPercentage();
  }
  console.log('this',this.duration_for_assign_reject);
}

getDateRange(){
  if(this.fromDate && this.toDate){
    this.getAssignRejectPercentage();
  }
}

getAssignRejectPercentage(){
  let payload = {
    shipper_id: this.selectedUnit._id,
    duration : this.duration_for_assign_reject.value,
  };
  if(this.isDate_rangeServiceQuality &&  this.fromDate && this.toDate){
    const from: any = DateTime.fromJSDate(this.fromDate).startOf('day').toUTC();
    const to: any = DateTime.fromJSDate(this.toDate).endOf('day').toUTC();
    payload['from_date'] = from.ts;
    payload['to_date'] = to.ts;
  }
  this.http.post('v1/shipper_stats/assignment_rejected_percentage',payload, 2).subscribe(
    (response: any)=>{
        if(response.data){
       let data = Number.parseFloat(response.data.assignedPercentage?response.data.assignedPercentage:0);
       //assigment data setting
       this.assignBottomlabel = data+'%';
       this.assignNeedleValue = data;
       const arc = (this.assignNeedleValue?this.assignNeedleValue:1);
       if(arc>=100){
         this.assignOptions.arcDelimiters=[99];
        }else{
           this.assignOptions.arcDelimiters=[arc];
        }
        // rejected data setting
        data = Number.parseFloat(response.data.rejectedPercentage?response.data.rejectedPercentage:0);
        this.rejectBottomlabel = data+'%';
        this.rejectNeedleValue = data;
        const arc1 = (this.rejectNeedleValue?this.rejectNeedleValue:1);
        if(arc1>=100){
          this.rejectOptions.arcDelimiters=[99];
        }else{
          this.rejectOptions.arcDelimiters=[arc1];
        }
        //accepted data setting
        data = Number.parseFloat(response.data.acceptedPercentage?response.data.acceptedPercentage:0);
        this.acceptBottomlabel = data+'%';
        this.acceptNeedleValue = data;
        const arc2 = (this.acceptNeedleValue?this.acceptNeedleValue:1);
        if(arc2>=100){
          this.acceptOptions.arcDelimiters=[99];
        }else{
          this.acceptOptions.arcDelimiters=[arc2];
        }

        // non-fullfilled data setting
        data = Number.parseFloat(response.data.non_fulfilledPercentage?response.data.non_fulfilledPercentage:0);
        this.non_fullfilledBottomlabel = data+'%';
        this.non_fullfilledNeedleValue = data;
        const arc3 = (this.non_fullfilledNeedleValue?this.non_fullfilledNeedleValue:1);
        if(arc3>=100){
          this.non_fullfilledOptions.arcDelimiters=[99];
        }
        else{
          this.non_fullfilledOptions.arcDelimiters=[arc3];
        }

        //fulfilled data setting
        data = Number.parseFloat(response.data.fulfilledPercentage?response.data.fulfilledPercentage:0);
        this.fulfilledBottomlabel = data+'%';
        this.fulfilledNeedleValue = data;
        const arc4 = (this.fulfilledNeedleValue?this.fulfilledNeedleValue:1);
        if(arc4>=100){
          this.fulfilledOptions.arcDelimiters=[99];
        }
        else{
          this.fulfilledOptions.arcDelimiters=[arc4];
        }
        this.totalAllocated = response.data.allocated?response.data.allocated:0;

      }
    })
  }
  
}
